export const environment = {
    production: true,
    apiUrl: 'https://safestreet-uat.tesisitaly.it/api/v1/',
    loginUrl: 'https://idp-safestreet.tesisitaly.it/',
    loginRealm: 'safe-street',
    loginClientId: 'safestreet',
    debugConsole: true,
    uploadFileMaxSize: 2,
};
